export default __webpack_public_path__ + "static/media/padideh-small.259678af.png";